import { render } from "./filter-icon.svg?vue&type=template&id=306d5f56"
import script from "./filter-icon.svg?vue&type=script&lang=js"
export * from "./filter-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3609/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__